import type { FC, SVGProps } from 'react';

const ResetEmailPassIcon: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.5 2.5C2.11929 2.5 1 3.61929 1 5V15L1.00003 15.0128C1.00695 16.3876 2.12357 17.5 3.5 17.5H10.375C10.7202 17.5 11 17.2202 11 16.875C11 16.5298 10.7202 16.25 10.375 16.25H3.5C2.92144 16.25 2.43468 15.8569 2.29221 15.3233L9.34272 10.9845L11 11.9789L19.75 6.72887V10.625C19.75 10.9702 20.0298 11.25 20.375 11.25C20.7202 11.25 21 10.9702 21 10.625V5C21 3.61929 19.8807 2.5 18.5 2.5H3.5ZM8.1351 10.2599L2.25 13.8815V6.72887L8.1351 10.2599ZM2.25 5.27113V5C2.25 4.30964 2.80964 3.75 3.5 3.75H18.5C19.1904 3.75 19.75 4.30964 19.75 5V5.27113L11 10.5211L2.25 5.27113Z"
        fill="currentColor"
      />
      <path
        d="M20.6503 16.25H23.5996C23.7586 16.25 23.8454 16.4354 23.7437 16.5575L22.269 18.3272C22.194 18.4171 22.0559 18.4171 21.9809 18.3272L20.5062 16.5575C20.4045 16.4354 20.4913 16.25 20.6503 16.25Z"
        fill="currentColor"
      />
      <path
        d="M12.4003 17.75H15.3496C15.5086 17.75 15.5954 17.5646 15.4937 17.4425L14.019 15.6728C13.944 15.5829 13.8059 15.5829 13.7309 15.6728L12.2562 17.4425C12.1544 17.5646 12.2413 17.75 12.4003 17.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9999 13.25C16.8356 13.25 15.7954 13.7802 15.107 14.6138C14.9751 14.7735 14.7387 14.796 14.579 14.6641C14.4193 14.5323 14.3968 14.2959 14.5287 14.1362C15.3534 13.1375 16.6024 12.5 17.9999 12.5C20.2062 12.5 22.041 14.0874 22.4258 16.1823C22.4299 16.2048 22.4339 16.2274 22.4377 16.25H21.675C21.3277 14.5383 19.8139 13.25 17.9999 13.25ZM14.3249 17.75C14.6721 19.4617 16.186 20.75 17.9999 20.75C19.1643 20.75 20.2045 20.2198 20.8929 19.3862C21.0248 19.2265 21.2612 19.204 21.4209 19.3359C21.5806 19.4677 21.6031 19.7041 21.4712 19.8638C20.6464 20.8625 19.3975 21.5 17.9999 21.5C15.7937 21.5 13.9589 19.9126 13.5741 17.8177C13.57 17.7952 13.566 17.7726 13.5622 17.75H14.3249Z"
        fill="currentColor"
      />
      <path
        d="M20.6503 16.25H23.5996C23.7586 16.25 23.8454 16.4354 23.7437 16.5575L22.269 18.3272C22.194 18.4171 22.0559 18.4171 21.9809 18.3272L20.5062 16.5575C20.4045 16.4354 20.4913 16.25 20.6503 16.25Z"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
      <path
        d="M12.4003 17.75H15.3496C15.5086 17.75 15.5954 17.5646 15.4937 17.4425L14.019 15.6728C13.944 15.5829 13.8059 15.5829 13.7309 15.6728L12.2562 17.4425C12.1544 17.5646 12.2413 17.75 12.4003 17.75Z"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9999 13.25C16.8356 13.25 15.7954 13.7802 15.107 14.6138C14.9751 14.7735 14.7387 14.796 14.579 14.6641C14.4193 14.5323 14.3968 14.2959 14.5287 14.1362C15.3534 13.1375 16.6024 12.5 17.9999 12.5C20.2062 12.5 22.041 14.0874 22.4258 16.1823C22.4299 16.2048 22.4339 16.2274 22.4377 16.25H21.675C21.3277 14.5383 19.8139 13.25 17.9999 13.25ZM14.3249 17.75C14.6721 19.4617 16.186 20.75 17.9999 20.75C19.1643 20.75 20.2045 20.2198 20.8929 19.3862C21.0248 19.2265 21.2612 19.204 21.4209 19.3359C21.5806 19.4677 21.6031 19.7041 21.4712 19.8638C20.6464 20.8625 19.3975 21.5 17.9999 21.5C15.7937 21.5 13.9589 19.9126 13.5741 17.8177C13.57 17.7952 13.566 17.7726 13.5622 17.75H14.3249Z"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default ResetEmailPassIcon;
